import { TabProps } from "../Tab";

/**
 * Gets the selected tab ID.
 * @param id The raw ID to get the selected ID from.
 * @param tabs The set of available tabs.
 * @returns The selected tab ID, or null if not specified or no tabs available.
 */
export function getSelectedId(id: string | null | undefined, tabs: ReadonlyArray<TabProps>): string | null {
  if (id === null) return null;
  if (tabs.length === 0) return null;
  if (id === undefined) {
    for (const tab of tabs) {
      const { id, disabled = false } = tab;
      if (!disabled) return id;
    }
    return null;
  }

  const tab = tabs.find((tab) => tab.id === id);
  if (!tab) return null;

  return id;
}
